import { classifyDetour, detourLabel } from '../lib/detour';

type Props = { minutes: number };

export function DetourPill({ minutes }: Props) {
  const cls = classifyDetour(minutes);
  const variant = cls === 'far' ? 'far' : 'near';
  return <span className={`detour-pill detour-pill--${variant}`}>{detourLabel(minutes)}</span>;
}
